import React from "react";
import { motion } from "framer-motion";

interface StepContainerProps {
  children: React.ReactNode;
  className?: string;
}

const StepContainer: React.FC<StepContainerProps> = ({
  children,
  className = "",
}) => {
  return (
    <motion.div
      className={`w-full max-w-2xl mx-auto ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
      }}
    >
      {children}
    </motion.div>
  );
};

export default StepContainer;
